import { createContext, Dispatch, SetStateAction } from 'react'

import { FilterValue } from 'components/Filter'
import { CommonFormContextProps } from 'components/Form'

export type AdUnitListContextType = CommonFormContextProps & {
  filters: FilterValue[]
  setFilters: Dispatch<SetStateAction<FilterValue[]>>
}

export const AdUnitListContext = createContext<AdUnitListContextType>({} as AdUnitListContextType)
